module.exports = __webpack_public_path__ + "img/d201002-2.533e9180.jpg";